import * as React from 'react';
import InputMask from 'react-input-mask';

interface EditableFieldProps {
    label: string;
    value: string;
    isPhoneInput: boolean;
    onChangeAction: (newValue: string) => void;
}

export const ProspectInfoRowEditable = (props: EditableFieldProps) => {
    return (
        <div className="row">
            <div className={'col-sm-5 font-weight-bold mt-2'}>{props.label}</div>
            <div className="col-sm-7">
                {props.isPhoneInput ? (
                    <InputMask
                        className={`form-control`}
                        value={props.value}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            props.onChangeAction(e.target.value)
                        }
                        placeholder={'(444) 444-4444'}
                        mask={'(999) 999-9999'}
                        pattern={'[(][2-9]{1}[0-9]{2}[)] [0-9]{3}-[0-9]{4}'}
                    />
                ) : (
                    <input
                        className={`form-control`}
                        value={props.value}
                        onChange={e => props.onChangeAction(e.target.value)}
                    />
                )}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/dashboardWidgets/prospectInfoRowEditable.tsx